/** Subscription list price copy for US clinical host (app.aurorageriatric.com). */
export const USA_PRO_MONTHLY_PRICE_LABEL = "US$69/month";

export function isUsClinicalHost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  return (
    host === "app.aurorageriatric.com" ||
    host === "aurorageriatric.com" ||
    host === "www.aurorageriatric.com"
  );
}

export function isUsDemoMode() {
  if (typeof window === "undefined") return false;
  if (!isUsClinicalHost()) return false;
  return new URLSearchParams(window.location.search).get("us_demo") === "1";
}
